<template>
  <div>
    <sidebar-item
      :link="{
              name: 'Painel de notificações',
              icon: 'tim-icons icon-bell-55',
              path: {name: 'finance_manager.finance.panel_notification'}
            }"
      :notify="panel_notifications.length"
    />
    <sidebar-item
      v-if="$hasRole(role.FINANCE_MANAGER.value)"
      :material="true"
      :link="{
            name: 'Tomadores/Documentação',
            icon: 'group',
            path: {name: 'finance_manager.finance.takers'}
          }"
    />
    <sidebar-item
      v-if="$canAny([permission.FINANCE__ADMIN.value])
              && $hasRole(role.FINANCE_MANAGER.value)"
      :material="true"
      :link="{
            name: 'Instituição Financeira',
            icon: 'business',
            path: {name: 'finance_manager.fintech'}
          }"
    />
    <sidebar-item
      v-if="$canAny([permission.FINANCE__ADMIN.value])
              && $hasRole(role.FINANCE_MANAGER.value)"
      :material="true"
      :link="{
            name: 'Usuarios',
            icon: 'groups',
            path: {name: 'finance_manager.finance.users'}
          }"
    />

    <sidebar-item
      v-if="$canAny([permission.FINANCE__ADMIN.value])
              && $hasRole(role.FINANCE_MANAGER.value)"
      :link="{
            name: 'Configuração',
            icon: 'tim-icons icon-settings-gear-63',
            path: {name: 'finance_manager.finance.attachments'}
          }"
    />
    <sidebar-item
      v-if="$hasRole(role.FINANCE_MANAGER.value)"
      :link="{
            name: $t('sidebar.quotes'),
            icon: 'tim-icons icon-paper',
            path: {name: 'finance_manager.finance'}
          }"
    />

  </div>
</template>

<script>
  import userPermission from "@/util/valueObjects/userPermission";
  import userRole from "@/util/valueObjects/userRole";

  export default {
    name: "sidebar",
    props: {
      panel_notifications: {
        type: Array
      }
    },
    data() {
      return {
        role: userRole,
        permission: userPermission,
      }
    },
  }
</script>

<style scoped>

</style>
